import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';

import { dataLayerPush } from '@r1-frontend/analytics/dataLayerPush';

import { CATEGORIES, EVENTS } from '@r1-frontend/shared/constants/analytics';

import ConnectDomruPopupGroup from '~/src/components/ConnectDomruPopup';
import { setView } from '~/src/components/ConnectDomruPopup/context/actions';
import { useContextDispatch } from '~/src/components/ConnectDomruPopup/context/hooks';
import { TPopupGroupState } from '~/src/components/ConnectDomruPopup/context/initialState';
import UnauthDesktopHeader from '~/src/features/_layout/Header/desktop/components/UnauthDesktopHeader';
import UnauthMobileHeader from '~/src/features/_layout/Header/mobile/UnauthMobileHeader';
import { IUnauthHeaderProps } from '~/src/features/_layout/Header/types';
import { selectUnauthMenu } from '~/src/store/selectors/menu/selectMenu';

export const UnauthHeader = () => {
    const newMenuItems = useSelector(selectUnauthMenu);
    const { asPath } = useRouter();
    const dispatch = useContextDispatch();

    const togglePopupState = useCallback((state: TPopupGroupState) => {
        if (state === 'connect') {
            dataLayerPush({
                event: EVENTS.UAevent,
                category: CATEGORIES.mainMenuClick,
                action: 'Подключить Дом.ру',
                label: 'menu_new',
            });
        }

        dispatch(setView(state));
    }, []);

    const props: IUnauthHeaderProps = {
        items: newMenuItems,
        onBecomeClientHandler: togglePopupState,
        referrerPath: `?referrer=${decodeURIComponent(asPath)}`,
    };

    return (
        <>
            <UnauthDesktopHeader {...props}/>
            <UnauthMobileHeader {...props}/>
            <ConnectDomruPopupGroup/>
        </>
    );
};
